import type { GlobalToken } from "antd";

// import { customExtraTokens } from "#src/styles/theme/antd/antd-theme";
import { getCSSVariablesByTokens } from "./utils";
// import { customExtraTokens } from "./antd-theme";

/**
 * Setup antd theme tokens and custom figma tokens to html
 * @see https://ant.design/docs/spec/colors
 */
export function setupAntdThemeTokensToHtml(antdTokens: GlobalToken) {
	// Detect if we are in dark mode (simple check, can be improved based on your app state)
	// const isDark = document.documentElement.classList.contains('dark');

	// Merge standard Antd tokens with our custom Mode 1 tokens
	const mergedTokens = {
		...antdTokens,
		// ...customExtraTokens(isDark),
	};

	const cssVariablesString = getCSSVariablesByTokens(mergedTokens);

	const styleId = "antd-theme-tokens";
	const styleSheet = document.querySelector(`#${styleId}`) || document.createElement("style");
	styleSheet.id = styleId;
	styleSheet.textContent = `:root { ${cssVariablesString} }`;
	document.head.appendChild(styleSheet);
}
